import { Link, createFileRoute } from "@tanstack/react-router";
import ArrowForward from "../assets/landing/arrow-forward.svg?react";
import CompanyConsoleIcon from "../assets/landing/company-console.svg?react";
import StoreConsoleIcon from "../assets/landing/store-console.svg?react";
import {
  type ConsoleLandingCard,
  ConsoleLandingPage,
} from "../components/console-landing-page";
import {
  COMPANY_TOKEN_STORAGE_KEY,
  STORE_TOKEN_STORAGE_KEY,
  validateToken,
} from "../libs/auth";
import { getTenantSlug } from "../libs/utils";

export const Route = createFileRoute("/")({
  component: RouteComponent,
});

function isLoggedIn(tokenStorageKey: string) {
  return validateToken(localStorage.getItem(tokenStorageKey));
}

export function RouteComponent() {
  const isCompanyLoggedIn = isLoggedIn(COMPANY_TOKEN_STORAGE_KEY);
  const isStoreLoggedIn = isLoggedIn(STORE_TOKEN_STORAGE_KEY);
  const shouldShowStoreConsole = getTenantSlug() !== "miyagi";
  const cards: ConsoleLandingCard[] = [
    {
      ctaTone: isCompanyLoggedIn ? "accent" : "default",
      description: isCompanyLoggedIn ? "ログイン中" : "ログイン",
      icon: <CompanyConsoleIcon />,
      title: "事業者コンソール",
      to: "/login/company",
    },
  ];

  if (shouldShowStoreConsole) {
    cards.push({
      ctaTone: isStoreLoggedIn ? "accent" : "default",
      description: isStoreLoggedIn ? "ログイン中" : "ログイン",
      icon: <StoreConsoleIcon />,
      title: "店舗コンソール",
      to: "/login/store",
    });
  }

  return (
    <ConsoleLandingPage
      arrowIcon={<ArrowForward />}
      cards={cards}
      renderLink={({ children, className, to }) => (
        <Link to={to} className={className}>
          {children}
        </Link>
      )}
    />
  );
}
